const psrStone = '/psrs/psr-stone-v2.png';
const psrTon = '/psrs/psr-ton.png';
const psrPayGo = '/psrs/psr-paygo-novo-v2.png';
const psrBin = '/psrs/psr-bin-novo-v3.png';
const psrPagSeguro = '/psrs/psr-pagseguro-novo-v2.png';
const psrCielo = '/psrs/psr-cielo-v3.png';
const psrAfinz = '/psrs/psr-afinz-v3.svg';
const psrMercadoPago = '/psrs/mercado-pago-logo-novo-v2.png';
const psrSitef = '/psrs/psr-sitef.png';
const psrUnica = '/psrs/psr-unica-v2.png';
const psrSicredi = '/psrs/psr-sicredi-v2.png';
const psrSipag = '/psrs/psr-sipag-sicoob.svg';
const psrAzulzinha = '/psrs/psr-azulzinha-v3.svg';
const psrAdyen = '/psrs/psr-adyen.png';
const psrVero = '/psrs/psr-vero-v3.png';
const psrSafrapay = '/psrs/psr-safrapay-v2.png';
const psrRede = '/psrs/psr-rede.v2.png';
const psrPicpay = '/psrs/psr-picpay.svg';
const psrGetnet = '/psrs/psr-getnet-v2.png';
const psriFood = '/psrs/psr-ifood.svg';
const psrYuno = '/psrs/psr-yuno-v1.png';
const psrSumup = '/psrs/psr-sumup-v1.png';
const psr99Food = '/psrs/psr-99food.png';
const psrKeeta = '/psrs/psr-keeta.svg';
const psrQlub = '/psrs/psr-qlub.png';
const psrQlic = '/psrs/psr-qlic.png';
const psrBs2Adiq = '/psrs/psr-bs2-adiq-v1.png';
const psrXp = '/psrs/psr-xp-v1.png';
const psrCresol = '/psrs/psr-cresol-v1.svg';
const psrBcj = '/psrs/psr-bcj-v1.png';
const psrPortoBank = '/psrs/psr-portobank-v1.svg';
const psrUnicred = '/psrs/psr-unicred-v1.png';

export const PARTNER_MACHINES = [
  {id: 'stone', name: 'Stone', image: psrStone},
  {id: 'ton', name: 'Ton', image: psrTon},
  {id: 'paygo', name: 'C6 Pay', image: psrPayGo},
  {id: 'pagseguro', name: 'PagSeguro', image: psrPagSeguro},
  {id: 'cielo', name: 'Cielo', image: psrCielo},
  {id: 'afinz', name: 'Afinz', image: psrAfinz},
  {id: 'mercadopago', name: 'Mercado Pago', image: psrMercadoPago},
  {id: 'sitef', name: 'Sitef', image: psrSitef},
  {id: 'unica', name: 'Unica', image: psrUnica},
  {id: 'sicredi', name: 'Sicredi', image: psrSicredi},
  {id: 'sipag', name: 'Sipag', image: psrSipag},
  {id: 'azulzinha', name: 'Azulzinha', image: psrAzulzinha},
  {id: 'adyen', name: 'Adyen', image: psrAdyen},
  {id: 'sumup', name: 'Sumup', image: psrSumup},
  {id: 'safrapay', name: 'Safrapay', image: psrSafrapay},
  {id: 'rede', name: 'Rede', image: psrRede},
  {id: 'picpay', name: 'Picpay', image: psrPicpay},
  {id: 'getnet', name: 'Getnet', image: psrGetnet},
  {id: 'ifood', name: 'iFood', image: psriFood},
  {id: 'yuno', name: 'Yuno', image: psrYuno},
  {id: 'qlub', name: 'Qlub', image: psrQlub},
  {id: '99food', name: '99Food', image: psr99Food},
  {id: 'vero', name: 'Vero', image: psrVero},
  {id: 'keeta', name: 'Keeta', image: psrKeeta},
  {id: 'bin', name: 'Bin', image: psrBin},
  {id: 'qlic', name: 'Qlic', image: psrQlic},
  {id: 'bs2adiq', name: 'BS2 Adiq', image: psrBs2Adiq},
  {id: 'xp', name: 'XP', image: psrXp},
  {id: 'cresol', name: 'Cresol', image: psrCresol},
  {id: 'bcj', name: 'BCJ', image: psrBcj},
  {id: 'portobank', name: 'PortoBank', image: psrPortoBank},
  {id: 'unicred', name: 'Unicred', image: psrUnicred}
];
